import { render, staticRenderFns } from "./indexBackup.vue?vue&type=template&id=765ebac2&scoped=true"
import script from "./indexBackup.vue?vue&type=script&lang=js"
export * from "./indexBackup.vue?vue&type=script&lang=js"
import style0 from "./indexBackup.vue?vue&type=style&index=0&id=765ebac2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "765ebac2",
  null
  
)

export default component.exports